import { render, staticRenderFns } from "./CustTagModal.vue?vue&type=template&id=63aef264"
import script from "./CustTagModal.vue?vue&type=script&lang=js"
export * from "./CustTagModal.vue?vue&type=script&lang=js"
import style0 from "./CustTagModal.vue?vue&type=style&index=0&id=63aef264&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports